import { ParamHistorical } from '../../../../../shared/types/param';

export interface PqrReceivedThroughParamsHistoricalProps {
    historical: ParamHistorical[];
    showHistorical?: boolean;
}

export const fieldEquivalences: { [key: string]: string } = {
    createAt: 'Fecha de creación',
    name: 'Nombre',
    extra2: 'Descripción',
    active: 'Estado',
    parent: 'Tipo PQR',
};
